/**
 * Re-exports react-icons with correct React 18 TypeScript types.
 * react-icons returns ReactNode which conflicts with strict JSX typechecking.
 */
import React from 'react';
import {
  MdEmail as _MdEmail,
  MdLock as _MdLock,
  MdVisibility as _MdVisibility,
  MdVisibilityOff as _MdVisibilityOff,
  MdErrorOutline as _MdErrorOutline,
  MdCheckCircleOutline as _MdCheckCircleOutline,
} from 'react-icons/md';
import { FaMicrosoft as _FaMicrosoft } from 'react-icons/fa';
import {
  MdDashboard as _MdDashboard,
  MdPeople as _MdPeople,
  MdSecurity as _MdSecurity,
  MdSettings as _MdSettings,
  MdBarChart as _MdBarChart,
  MdMenu as _MdMenu,
  MdClose as _MdClose,
  MdLogout as _MdLogout,
  MdArrowUpward as _MdArrowUpward,
  MdArrowDownward as _MdArrowDownward,
  MdArrowForward as _MdArrowForward,
  MdCheckCircle as _MdCheckCircle,
  MdPending as _MdPending,
  MdBlock as _MdBlock,
  MdNotifications as _MdNotifications,
  MdKeyboardArrowRight as _MdKeyboardArrowRight,
  MdAnalytics as _MdAnalytics,
  MdSupportAgent as _MdSupportAgent,
  MdSend as _MdSend,
  MdSmartToy as _MdSmartToy,
  MdPlayArrow as _MdPlayArrow,
  MdStop as _MdStop,
  MdConfirmationNumber as _MdConfirmationNumber,
  MdPersonSearch as _MdPersonSearch,
  MdTaskAlt as _MdTaskAlt,
  MdAdd as _MdAdd,
  MdContentCopy as _MdContentCopy,
  MdCode as _MdCode,
  MdFileDownload as _MdFileDownload,
  MdUploadFile as _MdUploadFile,
  MdInsertDriveFile as _MdInsertDriveFile,
  MdDescription as _MdDescription,
  MdEdit as _MdEdit,
  MdCheck as _MdCheck,
  MdWarningAmber as _MdWarningAmber,
  MdInventory2 as _MdInventory2,
  MdWidgets as _MdWidgets,
  MdPerson as _MdPerson,
  MdTrendingUp as _MdTrendingUp,
  MdTableChart as _MdTableChart,
  MdSearch as _MdSearch,
  MdDeleteOutline as _MdDeleteOutline,
  MdSave as _MdSave,
  MdRefresh as _MdRefresh,
  MdArticle as _MdArticle,
  MdInfoOutline as _MdInfoOutline,
  MdCloudUpload as _MdCloudUpload,
} from 'react-icons/md';

type IconComponent = React.ComponentType<React.SVGProps<SVGSVGElement> & { className?: string }>;

export const MdEmail = _MdEmail as unknown as IconComponent;
export const MdLock = _MdLock as unknown as IconComponent;
export const MdVisibility = _MdVisibility as unknown as IconComponent;
export const MdVisibilityOff = _MdVisibilityOff as unknown as IconComponent;
export const MdErrorOutline = _MdErrorOutline as unknown as IconComponent;
export const MdCheckCircleOutline = _MdCheckCircleOutline as unknown as IconComponent;
export const FaMicrosoft = _FaMicrosoft as unknown as IconComponent;
export const MdDashboard = _MdDashboard as unknown as IconComponent;
export const MdPeople = _MdPeople as unknown as IconComponent;
export const MdSecurity = _MdSecurity as unknown as IconComponent;
export const MdSettings = _MdSettings as unknown as IconComponent;
export const MdBarChart = _MdBarChart as unknown as IconComponent;
export const MdMenu = _MdMenu as unknown as IconComponent;
export const MdClose = _MdClose as unknown as IconComponent;
export const MdLogout = _MdLogout as unknown as IconComponent;
export const MdArrowUpward = _MdArrowUpward as unknown as IconComponent;
export const MdArrowDownward = _MdArrowDownward as unknown as IconComponent;
export const MdArrowForward = _MdArrowForward as unknown as IconComponent;
export const MdCheckCircle = _MdCheckCircle as unknown as IconComponent;
export const MdPending = _MdPending as unknown as IconComponent;
export const MdBlock = _MdBlock as unknown as IconComponent;
export const MdNotifications = _MdNotifications as unknown as IconComponent;
export const MdKeyboardArrowRight = _MdKeyboardArrowRight as unknown as IconComponent;
export const MdAnalytics = _MdAnalytics as unknown as IconComponent;
export const MdSupportAgent = _MdSupportAgent as unknown as IconComponent;
export const MdSend = _MdSend as unknown as IconComponent;
export const MdSmartToy = _MdSmartToy as unknown as IconComponent;
export const MdPlayArrow = _MdPlayArrow as unknown as IconComponent;
export const MdStop = _MdStop as unknown as IconComponent;
export const MdConfirmationNumber = _MdConfirmationNumber as unknown as IconComponent;
export const MdPersonSearch = _MdPersonSearch as unknown as IconComponent;
export const MdTaskAlt = _MdTaskAlt as unknown as IconComponent;
export const MdAdd = _MdAdd as unknown as IconComponent;
export const MdContentCopy = _MdContentCopy as unknown as IconComponent;
export const MdCode = _MdCode as unknown as IconComponent;
export const MdFileDownload = _MdFileDownload as unknown as IconComponent;
export const MdUploadFile = _MdUploadFile as unknown as IconComponent;
export const MdInsertDriveFile = _MdInsertDriveFile as unknown as IconComponent;
export const MdDescription = _MdDescription as unknown as IconComponent;
export const MdEdit = _MdEdit as unknown as IconComponent;
export const MdCheck = _MdCheck as unknown as IconComponent;
export const MdWarningAmber = _MdWarningAmber as unknown as IconComponent;
export const MdInventory2 = _MdInventory2 as unknown as IconComponent;
export const MdWidgets = _MdWidgets as unknown as IconComponent;
export const MdPerson = _MdPerson as unknown as IconComponent;
export const MdTrendingUp = _MdTrendingUp as unknown as IconComponent;
export const MdTableChart = _MdTableChart as unknown as IconComponent;
export const MdSearch = _MdSearch as unknown as IconComponent;
export const MdDeleteOutline = _MdDeleteOutline as unknown as IconComponent;
export const MdSave = _MdSave as unknown as IconComponent;
export const MdRefresh = _MdRefresh as unknown as IconComponent;
export const MdArticle = _MdArticle as unknown as IconComponent;
export const MdInfoOutline = _MdInfoOutline as unknown as IconComponent;
export const MdCloudUpload = _MdCloudUpload as unknown as IconComponent;
